import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { MatchInfo } from 'react-linkify';
import { LinkDefinition } from './types';

// Example: in string 'View {link} or {link2}', finds '{link}' and '{link2}'
const linkReplacementRegex = /{[a-z0-9]+}/gi;

export const matchDecorator =
    (links: LinkDefinition[]) =>
    (text: string): MatchInfo[] =>
        pipe(
            [...text.matchAll(linkReplacementRegex)],
            array.map((match) => {
                const value = match[0];
                const { index } = match;

                if (index == null) return option.none;

                // Example: given value/placeholder '{link}', linkId will be 'link'
                const linkId = value.replace(/[{}]/g, '');
                return pipe(
                    links,
                    array.findFirst((link) => linkId === link.id),
                    option.map(
                        (linkDefinition): MatchInfo => ({
                            schema: '',
                            index,
                            lastIndex: index + value.length,
                            text: linkDefinition.text,
                            url: linkDefinition.url,
                        })
                    )
                );
            }),
            array.compact
        );
